import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const guides = [{
  title: 'Robotic Snow Blower Guide for Michigan',
  desc: 'How the Yarbo Snow Blower handles heavy lake-effect snow, long driveways, and freezing temperatures.',
  image: 'https://images.unsplash.com/photo-1517299321609-52687d1bc55a?auto=format&fit=crop&w=600&q=80',
  category: 'Winter Care'
}, {
  title: 'Robot Lawn Mower Michigan Guide',
  desc: 'Why wire-free RTK navigation is essential for Midwest lawns that experience frost heaves and seasonal changes.',
  image: 'https://images.unsplash.com/photo-1592424001807-593eb9863481?auto=format&fit=crop&w=600&q=80',
  category: 'Lawn Care'
}, {
  title: 'Yarbo for Large Properties & Lake Homes',
  desc: 'Managing up to 6 acres autonomously. Tips for multi-zone mapping and handling steep slopes down to the water.',
  image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&w=600&q=80',
  category: 'Property Management'
}, {
  title: 'Yarbo Lawn Mower vs Lawn Mower Pro',
  desc: 'A detailed breakdown of the standard and Pro modules to help you choose the right cutting power for your grass type.',
  image: 'https://placehold.co/600x400/1A1A1A/FACC15?text=Mower+vs+Pro',
  category: 'Product Comparison'
}, {
  title: 'Best Yarbo Bundle for Michigan',
  desc: 'Breaking down the cost and benefits of the All-Season Pro Bundle vs buying modules separately.',
  image: 'https://placehold.co/600x400/1A1A1A/FACC15?text=Bundles',
  category: 'Buying Advice'
}, {
  title: 'Preparing Your Yard for Yarbo',
  desc: 'Simple steps to get your property ready for autonomous mowing and snow clearing.',
  image: 'https://images.unsplash.com/photo-1558904541-efa843a96f09?auto=format&fit=crop&w=600&q=80',
  category: 'Setup'
}];
export function Guides() {
  return <div className="bg-gray-50 min-h-screen py-12 lg:py-20" data-id="element-281">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-282">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-283">
          <div className="inline-flex items-center justify-center p-3 bg-yarbo-yellow/20 rounded-full mb-4" data-id="element-284">
            <BookOpen className="w-8 h-8 text-yarbo-dark" data-id="element-285" />
          </div>
          <h1 className="text-4xl md:text-5xl font-extrabold text-yarbo-dark mb-6" data-id="element-286">
            Yarbo Buying Guides for Michigan Homeowners
          </h1>
          <p className="text-lg text-gray-600" data-id="element-287">
            Resources, comparisons, and expert advice from Merem Robotics to
            help you automate your property maintenance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-288">
          {guides.map((guide, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-200 hover:shadow-lg transition-shadow group flex flex-col h-full" data-id="element-289">
              <div className="aspect-[16/9] overflow-hidden relative" data-id="element-290">
                <img src={guide.image} alt={guide.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-291" />
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-yarbo-dark" data-id="element-292">
                  {guide.category}
                </div>
              </div>
              <div className="p-6 flex flex-col flex-grow" data-id="element-293">
                <h3 className="text-xl font-bold text-yarbo-dark mb-3 group-hover:text-yarbo-yellow transition-colors" data-id="element-294">
                  {guide.title}
                </h3>
                <p className="text-gray-600 text-sm mb-6 flex-grow" data-id="element-295">
                  {guide.desc}
                </p>
                <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-296">
                  <span className="text-yarbo-dark font-bold text-sm flex items-center group-hover:text-yarbo-yellow transition-colors cursor-pointer" data-id="element-297">
                    Read Guide <ArrowRight className="ml-2 w-4 h-4" data-id="element-298" />
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-20 bg-yarbo-charcoal rounded-2xl p-8 md:p-12 text-center text-white relative overflow-hidden" data-id="element-299">
          <div className="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 bg-yarbo-yellow/20 rounded-full blur-2xl" data-id="element-300"></div>
          <div className="relative z-10" data-id="element-301">
            <h2 className="text-3xl font-bold mb-4" data-id="element-302">
              Need personalized advice?
            </h2>
            <p className="text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-303">
              Skip the reading and talk directly to a Michigan-based Yarbo
              expert. We can help you choose the right system for your specific
              property.
            </p>
            <Link to="/contact" className="btn-primary" data-id="element-304">
              Contact Merem Robotics
            </Link>
          </div>
        </div>
      </div>
    </div>;
}